<div class="row">
  <div class="col align-self-center">
    <div class="shadow p-2 mb-4 bg-white rounded">
      <div class="row px-2">
        <div class="col-md-3 col-6 my-1">
          <ng-select [(ngModel)]="selectedParentItem" placeholder="Filter by ISO" [items]="isoIdArray" bindLabel="dba" bindValue="id" (change)="getSelectedIso($event)" labelForId="IsoLbl" notFoundText="No ISO found" (clear)="clearMerchantSelect()">
          </ng-select>
        </div>       
        <div class="col-md-3 col-6 my-1">
          <ng-select [(ngModel)]="selectedChildItem" placeholder="Filter by Merchant" [items]="merchantIdArray" bindLabel="dba" bindValue="id" (change)="getSelectedMerchant($event)" labelForId="MerchantLbl" notFoundText="No merchant found" >
          </ng-select>
        </div>
        <div class="col-6 col-md-4">
        </div>
        <div class="col-3 col-md-1 my-1 text-right">
          <button type="button" (click)="refreshComponent()" triggers="mouseenter:mouseleave" ngbPopover="Refresh" class="btn btn-outline-primary btn-circle" title="Refresh"><i class="link-icon feather icon-refresh-cw"></i></button>
        </div>
        <div class="col-3 col-md-1 my-1">
          <button type="button" (click)="openModalWidgetDS(modalWidgetDS)" triggers="mouseenter:mouseleave" ngbPopover="DSS" class="btn btn-outline-primary btn-circle"  title="Customize"><i class="link-icon feather icon-tool"></i></button>
          <ng-template #modalWidgetDS let-modal>
            <div class="modal-header">
              <h5 class="modal-title">Dashboard Settings</h5>
              <button type="button" class="close" (click)="modal.close('by: close icon')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12 grid-margin stretch-card">
                  <div class="card-body">
                    Here you can opt what card rows to be shown / hide.<br><br>                    
                    <div class="field-checkbox">
                      <p-checkbox name="groupname" value="val1" [(ngModel)]="DSSelected" [disabled]="true" class="pcheckbox" inptId="TV"></p-checkbox>
                      <label for="TV">Transactions Volume</label>
                    </div>
                    <div class="field-checkbox">
                      <p-checkbox name="groupname" value="val2" [(ngModel)]="DSSelected" class="pcheckbox" inputId="TC"></p-checkbox>
                      <label for="TC">Transactions Count</label>
                    </div>
                    <div class="field-checkbox">
                      <p-checkbox name="groupname" value="val3" [(ngModel)]="DSSelected" class="pcheckbox" inputId="MB"></p-checkbox>
                      <label for="MB">Merchants Boarding</label>
                    </div>
                    <div class="field-checkbox">
                      <p-checkbox name="groupname" value="val4" [(ngModel)]="DSSelected" class="pcheckbox" inputId="MD"></p-checkbox>
                      <label for="MD">Merchants Deactivation</label>
                    </div>
                    <div class="field-checkbox">
                      <p-checkbox name="groupname" value="val5" [(ngModel)]="DSSelected" class="pcheckbox" inputId="MQ"></p-checkbox>
                      <label for="MQ">Merchants Quality</label>
                    </div>                    
                    <button type="button" (click)="DScheckbox(); modal.close();" class="btn btn-outline-primary btn-circle" style="float: right;">Save & Close</button>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="card-Head" *ngIf="onMerchantSelected == true">
      <h5>Merchant Score Cards</h5>
    </div>

    <div [ngClass]="isMobileView ? '' : 'row custom-column'" *ngIf="onMerchantSelected == true">
      <app-card [Volume]="merchantInSystem" [TimePeriod]="'Days in the system'" [List]="'List'"
        class="col-md-3 grid-margin stretch-card mx-auto" [cardColor]="'bgColor2'" [cardButton]="'card-button2'"
        [text]="'customerText'" [count]="'customer-count'" [isShow]="false">
      </app-card>
      <app-card [Volume]="daysFromLastTransact" [TimePeriod]="'Days since last transaction'" [List]="'List'"
        class="col-md-3 grid-margin stretch-card mx-auto" [cardColor]="'bgColor2'" [cardButton]="'card-button2'"
        [text]="'customerText'" [count]="'customer-count'" [isShow]="false">
      </app-card>
      <app-card [Volume]="numberOfStore +'/'+ numberOfTpn" [TimePeriod]="'Number of Stores | TPN'" [List]="'List'"
        class="col-md-3 grid-margin stretch-card mx-auto" [cardColor]="'bgColor2'" [cardButton]="'card-button2'"
        [text]="'customerText'" [count]="'customer-count'" [isShow]="false">
      </app-card>
      <app-card [Volume]="averageTicketSize" [TimePeriod]="'Average Ticket Size'" [List]="'List'"
        class="col-md-3 grid-margin stretch-card mx-auto" [cardColor]="'bgColor2'" [cardButton]="'card-button2'"
        [text]="'customerText'" [count]="'customer-count'" [isShow]="false">
      </app-card>
    </div>
    <div class="card-Head"*ngIf="showTileTV == true">
      <h5>Transactions Volume & Count</h5>
    </div>
    <div [ngClass]="isMobileView ? '' : 'row custom-column'" *ngIf="showTileTV == true">
      <app-card [Volume]="todayTransactionsVolume + '/'" [Count]="todayTransactionsCount" [TimePeriod]="TimePeriodtoday"
        [List]="'List'" class="col-md-3 grid-margin stretch-card mx-auto" 
        [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}"
        (navigateClicked)="navigateToTransaction({date:'today'}, todayTransactionsVolume)"
        (modelOpenTransactionVolume)="openWidget(commonMoalVolumeWidget, 'trend', 'today', 'volume')"
        (modelOpenTransactionCount)="openWidget(commonMoalCountWidget, 'trend', 'today', 'count')" [loaderId]="'today'"
        [cardColor]="'bgColor1'"  [text]="'custom-text-size-transaction'"[label]="'Transaction Volume'" [btnLabel]="'Transaction List'" [countlabel]="'Transaction Count'">
      </app-card>

      
      <ng-template #commonMoalVolumeWidget let-modal>
        <app-card-modal-widget [modalTitle]="title" [loaderId]="'today-volume'" [isChartShow]="isChartShow" [isShowDevice] ="true"
          [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true" [isShowSalesPerson]="false" [isGeoLocation]="false"
          [apexChartSPCustomers]="apexChartOptions" (closeModal)="modal.close('by: close icon')"
          (viewBySummary)="openWidget(null, 'trend','today','volume')" (deviceType)="openWidget91('day', 'today-volume')" (cardType)="openWidget92('day', 'today-volume')"
          (viewByChannel)="openWidget93('day', 'today-volume')" (viewByMode)="openWidget94('day', 'today-volume')" (viewByProcessor)="openWidget95('day', 'today-volume')">
        </app-card-modal-widget>
      </ng-template>
    
      <ng-template #commonMoalCountWidget let-modal>
        <app-card-modal-widget [modalTitle]="title" [loaderId]="'today-count'"
          [isChartShow]="isChartShow" [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true" [isShowSalesPerson]="false" [isGeoLocation]="false" [isShowDevice] ="true"
          [apexChartSPCustomers]="apexChartOptions" (closeModal)="modal.close('by: close icon')"
          (viewBySummary)="openWidget(null, 'trend','today','count')" (deviceType)="openWidget61('day', 'today-count')" (cardType)="openWidget62('day', 'today-count')"
          (viewByChannel)="openWidget63('day', 'today-count')" (viewByMode)="openWidget64('day', 'today-count')" (viewByProcessor)="openWidget65('day', 'today-count')">
        </app-card-modal-widget>
      </ng-template>
    
      <app-card [Volume]="currentMonthTransactionsVolume + '/'" [Count]="currentMonthTransactionsCount"
        [TimePeriod]="TimePeriodThismonth" [List]="'List'" [List]="'List'"
        class="col-md-3 grid-margin stretch-card mx-auto"  [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}"
        (navigateClicked)="navigateToTransaction({date:'current'}, currentMonthTransactionsVolume)"
        (modelOpenTransactionVolume)="openModalWidget9(modalWidget9,'loader-09')"
        (modelOpenTransactionCount)="openModalWidget6(modalWidget6, 'loader-09')" [loaderId]="'loader-09'" [cardColor]="'bgColor1'"
         [text]="'custom-text-size-transaction'" [label]="'Transaction Volume'" [btnLabel]="'Transaction List'" [countlabel]="'Transaction Count'">
      </app-card>
    
      <ng-template #modalWidget9 let-modal>
        <app-card-modal-widget [modalTitle]="thisMonthTransactionTitle" [loaderId]="'loader-0909'" [isChartShow]="isChartShow" [isShowDevice] ="true"
          [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true" [isShowSalesPerson]="false" [isGeoLocation]="false"
          [apexChartSPCustomers]="apexChart9Options" (closeModal)="modal.close('by: close icon')"
          (viewBySummary)="openWidget90('loader-0909')" (deviceType)="openWidget91()" (cardType)="openWidget92()"
          (viewByChannel)="openWidget93()" (viewByMode)="openWidget94()" (viewByProcessor)="openWidget95()">
        </app-card-modal-widget>
      </ng-template>
    
      <ng-template #modalWidget6 let-modal>
        <app-card-modal-widget [modalTitle]="'Processing Count - This Month'" [loaderId]="'loader-0606'"
          [isChartShow]="isChartShow" [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true" [isShowSalesPerson]="false" [isGeoLocation]="false" [isShowDevice] ="true"
          [apexChartSPCustomers]="apexChart6Options" (closeModal)="modal.close('by: close icon')"
          (viewBySummary)="openWidget60('loader-0606')" (deviceType)="openWidget61()" (cardType)="openWidget62()"
          (viewByChannel)="openWidget63()" (viewByMode)="openWidget64()" (viewByProcessor)="openWidget65()">
        </app-card-modal-widget>
      </ng-template>
    
      <app-card [Volume]="lastMonthTransactionsVolume + '/'" [Count]="lastMonthTransactionsCount"
        [TimePeriod]="TimePeriodLastmoth" [List]="'List'" class="col-md-3 grid-margin stretch-card mx-auto"  [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}"
        (navigateClicked)="navigateToTransaction({date:'last'}, lastMonthTransactionsVolume)"
        (modelOpenTransactionVolume)="openModalWidget8(modalWidget8,'loader-08')"
        (modelOpenTransactionCount)="openModalWidget5(modalWidget5,'loader-08')" [loaderId]="'loader-08'" [cardColor]="'bgColor1'"
         [text]="'custom-text-size-transaction'" [label]="'Transaction Volume'" [btnLabel]="'Transaction List'" [countlabel]="'Transaction Count'">
      </app-card>
    
      <ng-template #modalWidget8 let-modal>
        <app-card-modal-widget [modalTitle]="lastMonthTransactionTitle" [loaderId]="'loader-0808'" [isChartShow]="isChartShow" [isShowSalesPerson]="false" [isShowDevice] ="true"
          [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true" [isGeoLocation]="false"
          [apexChartSPCustomers]="apexChart8Options" (closeModal)="modal.close('by: close icon')"
          (viewBySummary)="openWidget80('loader-0808')" (deviceType)="openWidget81()" (cardType)="openWidget82()"
          (viewByChannel)="openWidget83()" (viewByMode)="openWidget84()" (viewByProcessor)="openWidget85()">
        </app-card-modal-widget>
      </ng-template>
    
      <ng-template #modalWidget5 let-modal>
        <app-card-modal-widget [modalTitle]="'Processing Count - Last Month'" [loaderId]="'loader-0505'"
          [isChartShow]="isChartShow" [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true" [isGeoLocation]="false" [isShowSalesPerson]="false" [isShowDevice] ="true"
          [apexChartSPCustomers]="apexChart5Options" (closeModal)="modal.close('by: close icon')"
          (viewBySummary)="openWidget50('loader-0505')" (deviceType)="openWidget51()" (cardType)="openWidget52()"
          (viewByChannel)="openWidget53()" (viewByMode)="openWidget54()" (viewByProcessor)="openWidget55()">
        </app-card-modal-widget>
      </ng-template>
    
      <app-card [Volume]="last3MonthTransactionsVolume + '/'" [Count]="last3MonthTransactionsCount" [TimePeriod]="'Last 3 Months'"
        [List]="'List'" class="col-md-3 grid-margin stretch-card mx-auto"  [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}"
        (navigateClicked)="navigateToTransaction({date:'threeMonth'}, last3MonthTransactionsVolume)"
        (modelOpenTransactionVolume)="openModalWidget7(modalWidget7,'loader-07')"
        (modelOpenTransactionCount)="openModalWidget4(modalWidget4,'loader-07')" [loaderId]="'loader-07'" [cardColor]="'bgColor1'"
        [text]="'custom-text-size-transaction'" [label]="'Transaction Volume'" [btnLabel]="'Transaction List'" [countlabel]="'Transaction Count'">
      </app-card>
    
      <ng-template #modalWidget7 let-modal>
        <app-card-modal-widget [modalTitle]="totalTransactionTitle" [loaderId]="'loader-0707'" [isChartShow]="isChartShow"
          [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true" [isGeoLocation]="false" [isShowSalesPerson]="false" [isShowDevice] ="true"
          [apexChartSPCustomers]="apexChart7Options" (closeModal)="modal.close('by: close icon')"
          (viewBySummary)="openWidget70('loader-0707')" (deviceType)="openWidget71()" (cardType)="openWidget72()"
          (viewByChannel)="openWidget73()" (viewByMode)="openWidget74()" (viewByProcessor)="openWidget75()">
        </app-card-modal-widget>
      </ng-template>
    
      <ng-template #modalWidget4 let-modal>
        <app-card-modal-widget [modalTitle]="'Processing Count - 12 Months'" [loaderId]="'loader-0404'"
          [isChartShow]="isChartShow" [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true" [isGeoLocation]="false" [isShowSalesPerson]="false" [isShowDevice] ="true"
          [apexChartSPCustomers]="apexChart4Options" (closeModal)="modal.close('by: close icon')"
          (viewBySummary)="openWidget40('loader-0404')" (deviceType)="openWidget41()" (cardType)="openWidget42()"
          (viewByChannel)="openWidget43()" (viewByMode)="openWidget44()" (viewByProcessor)="openWidget45()">
        </app-card-modal-widget>
      </ng-template>
    
    </div>
     
    <div class="card-Head" *ngIf="showTileCB == true">
      <h5>Customers Boarding</h5>
    </div>
    <div [ngClass]="isMobileView ? '' : 'row custom-column'"  *ngIf="showTileCB == true">
      <app-card class="col-md-3 grid-margin stretch-card mx-auto"  [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}" [Volume]="todayCustomersCount" [TimePeriod]="TimePeriodtoday" [List]="'List'"
        (navigateClicked)="getSPCustomerQuery('today','loader-CB01', todayCustomersCount)"
        (modelOpenClicked)="openModalWidgetSPCustomertoday(modalWidgetSPCustomer2,todayCustomersCount,'loader-CB01')"
        [loaderId]="'loader-CB01'" [cardColor]="'bgColor2'" [cardButton]="'card-button2'" [text]="'customerText'" [count]="'customer-count'" [btnLabel]="'Customer Count List'" [label]="'Customer Count'">
      </app-card>

      <app-card class="col-md-3 grid-margin stretch-card mx-auto"  [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}" [Volume]="thisMonthCustomersCount" [TimePeriod]="TimePeriodThismonth" [List]="'List'"
        (navigateClicked)="getSPCustomerQuery('thismonth','loader-CB02',thisMonthCustomersCount)"
        (modelOpenClicked)="customerSummaryThisMonth(modalWidgetSPCustomer2,'loader-CB02')"
        [loaderId]="'loader-CB02'" [cardColor]="'bgColor2'" [cardButton]="'card-button2'" [text]="'customerText'" [count]="'customer-count'" [btnLabel]="'Customer Count List'" [label]="'Customer Count'">
      </app-card>

      <app-card class="col-md-3 grid-margin stretch-card mx-auto"  [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}" [Volume]="lastMonthCustomersCount" [TimePeriod]="TimePeriodLastmoth" [List]="'List'"
        (navigateClicked)="getSPCustomerQuery('lastmonth','loader-CB03',lastMonthCustomersCount)"
        (modelOpenClicked)="customerSummaryLastMonth(modalWidgetSPCustomer2,'loader-CB03')"
        [loaderId]="'loader-CB03'" [cardColor]="'bgColor2'" [cardButton]="'card-button2'" [text]="'customerText'" [count]="'customer-count'" [btnLabel]="'Customer Count List'" [label]="'Customer Count'">
      </app-card>

      <app-card class="col-md-3 grid-margin stretch-card mx-auto"  [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}" [Volume]="overallCustomersCount" [TimePeriod]="TimePeriodOverall" [List]="'List'"
        (navigateClicked)="getSPCustomerQuery('overall','loader-CB04', overallCustomersCount)"
        (modelOpenClicked)="customerSummaryTotal(modalWidgetSPCustomer2,'loader-CB04')"
        [loaderId]="'loader-CB04'" [cardColor]="'bgColor2'" [cardButton]="'card-button2'" [text]="'customerText'" [count]="'customer-count'" [btnLabel]="'Customer Count List'" [label]="'Customer Count'">
      </app-card>
      
      <ng-template #modalWidgetSPCustomer2 let-modal>
        <app-card-modal-widget [modalTitle]="modalTitle" [loaderId]="loaderId" [isChartShow]="isChartShow"
          [isStateShow]="isStateShow" [isShowLabel]="isShowLabel"  [apexChartSPCustomers]="apexChartSPCustomers" [configUSChart]="configUSChart" (closeModal)="modal.close('by: close icon')" (viewBySummary)="openWidgetSPCustomer4(loaderId,period)" (salesperson)="openWidgetSPCustomer2(loaderId,period)" (geoLocation)="openModalWidgetSPCustomer7(modalWidgetSPCustomer2, period, customersCount,loaderId)">
        </app-card-modal-widget>
      </ng-template>

    </div>
    <div class="card-Head" *ngIf="element == true && showTileMA == true">
      <h5>Merchants Boarding</h5>
    </div>
    <div [ngClass]="isMobileView ? '' : 'row custom-column'" *ngIf="element == true && showTileMA == true">
     
      <app-card class="col-md-3 grid-margin stretch-card mx-auto"
        [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}" [Volume]="todayMerchantCount +' / '+ todayTPNCount"
        [TimePeriod]="TimePeriodtoday" [List]="'List'"
        (navigateClicked)="navigateToMerchant({dateRange:'Today'}, todayMerchantCount)"
        (modelOpenClicked)="showNTTPNCard ? openWidget131(modalWidget13,'loader-15') : openModalWidget13(modalWidget13,'loader-15')"
        [loaderId]="'loader-15'" [cardColor]="'bgColor3'" [btnLabel]="'View Active Merchants List'"
        [label]="'Merchant Volume / TPN'">
      </app-card>

      <ng-template #modalWidget13 let-modal>
        <app-card-modal-widget [modalTitle]="todayMerchantTitle" [loaderId]="'loader-1515'" [isChartShow]="isChartShow"
          [isChart2Show]="isChart2Show" [apexChart2Show]="chart2MerchantToday" [show12Month]='viewByDevice'
          [isStateShow]="isStateShow" [apexChartSPCustomers]="apexChart13Options" [configUSChart]="chartUSMerchantTD"
          [isShowDevice]="true" [isShowCustomer]="true" (closeModal)="modal.close('by: close icon')"
          (salesperson)="openWidgetSPtoday()" (viewByCustomer)="openWidget130('loader-1515')"
          (deviceType)="openWidget131(null,'loader-1515')" [swapLabel]="'dashboard.viewTodayDeviceAcquisition' | translate">
        </app-card-modal-widget>
      </ng-template>

      <app-card class="col-md-3 grid-margin stretch-card mx-auto"
        [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}" [Volume]="currentMonthMerchant +' / '+ currentMonthTPN"
        [TimePeriod]="TimePeriodThismonth" [List]="'List'"
        (navigateClicked)="navigateToMerchant({dateRange:'thisMonth'}, currentMonthMerchant)"
        (modelOpenClicked)="showNTTPNCard ? openWidget33(modalWidget3,'loader-03') : openModalWidget35(modalWidget3,'loader-03')"
        [loaderId]="'loader-03'" [cardColor]="'bgColor3'" [btnLabel]="'View Active Merchants List'"
        [label]="'Merchant Volume / TPN'">
      </app-card>

      <ng-template #modalWidget3 let-modal>
        <app-card-modal-widget [modalTitle]="thisMonthMerchantTitle" [loaderId]="'loader-0303'" [isChartShow]="isChartShow"
          [isStateShow]="isStateShow" [isShowLabel]="isShowLabel" [apexChartSPCustomers]="apexChart3Options"
          [isChart2Show]="isChart2Show" [apexChart2Show]="chart2MerchantThisMonth" [show12Month]='viewByDevice'
          [configUSChart]="chartUSMerchantTM" [isShowDevice]="true" [isShowCustomer]="true"
          (closeModal)="modal.close('by: close icon')" (salesperson)="openWidgetSPthisMonth()"
          (viewByCustomer)="openWidget30('loader-0303')" (deviceType)="openWidget33(null,'loader-0303')"
          (geoLocation)="openWidget34MerchantGeoMap('thismonth')" (viewBySummary)="openWidget3()" [swapLabel]="'dashboard.viewThisMonthDeviceAcquisition' | translate">
        </app-card-modal-widget>
      </ng-template>

      <app-card class="col-md-3 grid-margin stretch-card mx-auto"
        [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}" [Volume]="lastMonthMerchant +' / '+ lastMonthTPN"
        [TimePeriod]="TimePeriodLastmoth" [List]="'List'"
        (navigateClicked)="navigateToMerchant({dateRange:'lastMonth'}, lastMonthMerchant)"
        (modelOpenClicked)="showNTTPNCard ? openWidget21(modalWidget2,'loader-02') : openModalWidget25(modalWidget2,'loader-02')"
        [loaderId]="'loader-02'" [cardColor]="'bgColor3'" [btnLabel]="'View Active Merchants List'"
        [label]="'Merchant Volume / TPN'">
      </app-card>

      <ng-template #modalWidget2 let-modal>
        <app-card-modal-widget [modalTitle]="lastMonthMerchantTitle" [loaderId]="'loader-0202'" [isChartShow]="isChartShow"
          [isChart2Show]="isChart2Show" [apexChart2Show]="chart2MerchantLastMonth" [show12Month]='viewByDevice'
          [isStateShow]="isStateShow" [isShowLabel]="isShowLabel" [apexChartSPCustomers]="apexChart2Options"
          [configUSChart]="chartUSMerchantLM" [isShowDevice]="true" [isShowCustomer]="true"
          (closeModal)="modal.close('by: close icon')" (salesperson)="openWidgetSPlastMonth()"
          (viewByCustomer)="openWidget20('loader-0202')" (deviceType)="openWidget21(null,'loader-0202')"
          (geoLocation)="openWidget24MerchantGeoMap('lastmonth')" (viewBySummary)="openWidget2()" [swapLabel]="'dashboard.viewLastMonthDeviceAcquisition' | translate">
        </app-card-modal-widget>
      </ng-template>
     
      <app-card class="col-md-3 grid-margin stretch-card mx-auto"
        [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}" [Volume]="totalMerchant +' / '+ totalTPN"
        [TimePeriod]="TimePeriodOverall" [List]="'List'" (navigateClicked)="naviagteMerchantList(totalMerchant)"
        (modelOpenClicked)="showNTTPNCard ? openWidget11(modalWidget1,'loader-01'): openModalWidget15(modalWidget1,'loader-01')"[loaderId]="'loader-01'" [cardColor]="'bgColor3'" [btnLabel]="'View Active Merchants List'"
        [label]="'Merchant Volume / TPN'">
      </app-card>

      <ng-template #modalWidget1 let-modal>
        <app-card-modal-widget [modalTitle]="totalMerchantTitle" [loaderId]="'loader-0101'" [isChartShow]="isChartShow"
          [isStateShow]="isStateShow" [isShowLabel]="isShowLabel" [apexChartSPCustomers]="apexChart1Options"
          [isChart2Show]="isChart2Show" [apexChart2Show]="chart2ShowOption" [configUSChart]="chartUSMerchantOL"
          [isShowDevice]="true" [isShowCustomer]="true" (closeModal)="modal.close('by: close icon')"
          (salesperson)="openWidgetSPtotal()" (viewByCustomer)="openWidget10('loader-0101')" [show12Month]='viewByDevice'
          (deviceType)="openWidget11(null,'loader-0101')" (geoLocation)="openWidget14MerchantGeoMap('overall')" (viewBySummary)="openWidget1()"  [swapLabel]="'dashboard.viewLast12MonthsDeviceAcquisition' | translate">
        </app-card-modal-widget>
      </ng-template>

    </div>

    <div class="card-Head" *ngIf="element == true && showTileMD == true">
      <h5>Merchants Deactive</h5>
    </div>

    <div [ngClass]="isMobileView ? '' : 'row custom-column'" *ngIf="element == true && showTileMD == true">

      <app-card class="col-md-3 grid-margin stretch-card mx-auto" [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}" [Volume]="todayMerchantDeactivatedCount +' / '+ todayTPNDeactivatedCount"
        [TimePeriod]="TimePeriodtoday" [List]="'List'"
        (navigateClicked)="getDeactivatedMerchantList('Today', todayMerchantDeactivatedCount,'loader-16')"
        (modelOpenClicked)="openModalWidgetMDToday(modalWidgetMDToday)" [loaderId]="'loader-16'" [cardColor]="'bgColor4'" [btnLabel]="'View Deactive Merchants List'" [label]="'Merchant Deactivation Count/TPN'">
      </app-card>

      <ng-template #modalWidgetMDToday let-modal>
        <app-card-modal-widget [modalTitle]="todayDeactiveMerchantTitle" [loaderId]="'loader-16'" [isChartShow]="isChartShow"  [apexChartSPCustomers]="apexChartMDTodayOptions" [dropdownBtn]="false"
          (closeModal)="modal.close('by: close icon')">
        </app-card-modal-widget>
      </ng-template>

      <app-card class="col-md-3 grid-margin stretch-card mx-auto" [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}" [Volume]="currentMonthMerchantDeactivated +' / '+ currentMonthTPNDeactivated"
        [TimePeriod]="TimePeriodThismonth" [List]="'List'"
        (navigateClicked)="getDeactivatedMerchantList('thisMonth', currentMonthMerchantDeactivated,'loader-12')"
        (modelOpenClicked)="openModalWidget12(modalWidget12,'loader-12')" [loaderId]="'loader-12'" [cardColor]="'bgColor4'" [btnLabel]="'View Deactive Merchants List'"  [label]="'Merchant Deactivation Count/TPN'">
      </app-card>

      <ng-template #modalWidget12 let-modal>
        <app-card-modal-widget [modalTitle]="thisMonthDeactiveMerchantTitle" [loaderId]="'loader-1212'" [isChartShow]="isChartShow" [isShowLabel]="isShowLabel" [apexChartSPCustomers]="apexChart12Options"
          (closeModal)="modal.close('by: close icon')" [isGeoLocation]="false" (salesperson)="openWidgetSPthisMonthMD()" (viewBySummary)="openWidget120('loader-1212')">
        </app-card-modal-widget>
      </ng-template> 
        
      <app-card class="col-md-3 grid-margin stretch-card mx-auto" [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}" [Volume]="lastMonthMerchantDeactivated +' / '+ lastMonthTPNDeactivated"
        [TimePeriod]="TimePeriodLastmoth" [List]="'List'"
        (navigateClicked)="getDeactivatedMerchantList('lastMonth', lastMonthMerchantDeactivated,'loader-11')"
        (modelOpenClicked)="openModalWidget11(modalWidget11,'loader-11')" [loaderId]="'loader-11'" [cardColor]="'bgColor4'"[btnLabel]="'View Deactive Merchants List'"  [label]="'Merchant Deactivation Count/TPN'">
      </app-card>

      <ng-template #modalWidget11 let-modal>
        <app-card-modal-widget [modalTitle]="lastMonthDeactiveMerchantTitle" [loaderId]="'loader-1111'" [isChartShow]="isChartShow" [isShowLabel]="isShowLabel" [apexChartSPCustomers]="apexChart11Options" [isGeoLocation]="false"
          (closeModal)="modal.close('by: close icon')" (viewBySummary)="openWidget110('loader-1111')" (salesperson)="openWidgetSPlastMonthMD()">
        </app-card-modal-widget>
      </ng-template>

      <app-card class="col-md-3 grid-margin stretch-card mx-auto" [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}" [Volume]="totalMerchantDeactivated +' / '+ totalTPNDeactivated"
        [TimePeriod]="TimePeriodOverall" [List]="'List'"
        (navigateClicked)="getDeactivatedMerchantList('', totalMerchantDeactivated,'loader-10')"
        (modelOpenClicked)="openModalWidget10(modalWidget10,'loader-10')" [loaderId]="'loader-10'" [cardColor]="'bgColor4'"[btnLabel]="'View Deactive Merchants List'"  [label]="'Merchant Deactivation Count/TPN'">
      </app-card>
      
      <ng-template #modalWidget10 let-modal>
        <app-card-modal-widget [modalTitle]="totalDeactiveMerchantTitle" [loaderId]="'loader-1010'" [isChartShow]="isChartShow" [isShowLabel]="isShowLabel" [apexChartSPCustomers]="apexChart10Options" [isGeoLocation]="false"
          (closeModal)="modal.close('by: close icon')" (viewBySummary)="openWidget100('loader-1010')" (salesperson)="openWidgetSPtotalMD()" >
        </app-card-modal-widget>
      </ng-template>

    </div>
    <div class="card-Head" *ngIf="showTileTV == true && last30TVShow == true">
      <h5>Transactions Volume</h5>
    </div>

    <div  *ngIf="showTileTV == true && last30TVShow == true">      
        <apx-chart [series]="apexChartTVDefault30.series" [chart]="apexChartTVDefault30.chart"
        [dataLabels]="apexChartTVDefault30.dataLabels" [plotOptions]="apexChartTVDefault30.plotOptions"
        [responsive]="apexChartTVDefault30.responsive" [xaxis]="apexChartTVDefault30.xaxis"
        [legend]="apexChartTVDefault30.legend" [fill]="apexChartTVDefault30.fill" [title]="apexChartTVDefault30.title"
        [colors]="apexChartTVDefault30.colors" [grid]="apexChartTVDefault30.grid" [tooltip]="apexChartTVDefault30.tooltip"></apx-chart>

        <ngx-ui-loader [bgsColor]="'red'" [fgsColor]="'red'" [pbColor]="'red'" [bgsOpacity]="1"
        [loaderId]="'loader-defaultTV30'" [bgsPosition]="'center-center'">
        </ngx-ui-loader>
    </div>

    

    <div class="card-Head" *ngIf="showTileTC == true && last30TCShow == true">
      <h5>Transactions Count</h5>
    </div>

    <div *ngIf="showTileTC == true && last30TCShow == true">
        <apx-chart [series]="apexChartTCDefault30.series" [chart]="apexChartTCDefault30.chart"
        [dataLabels]="apexChartTCDefault30.dataLabels" [plotOptions]="apexChartTCDefault30.plotOptions"
        [responsive]="apexChartTCDefault30.responsive" [xaxis]="apexChartTCDefault30.xaxis"
        [legend]="apexChartTCDefault30.legend" [fill]="apexChartTCDefault30.fill" [title]="apexChartTCDefault30.title"
        [colors]="apexChartTCDefault30.colors" [grid]="apexChartTCDefault30.grid" [tooltip]="apexChartTCDefault30.tooltip"></apx-chart>

      <ngx-ui-loader [bgsColor]="'red'" [fgsColor]="'red'" [pbColor]="'red'" [bgsOpacity]="1"
      [loaderId]="'loader-defaultTC30'" [bgsPosition]="'center-center'">
      </ngx-ui-loader>
    </div>

    

    <div class="card-Head" *ngIf="showTileCB == true && last30CBShow == true">
      <h5>Customers Boarding</h5>
    </div>

    <div *ngIf="showTileCB == true && last30CBShow == true">
      <apx-chart [series]="apexChartCBDefault30.series" [chart]="apexChartCBDefault30.chart"
      [dataLabels]="apexChartCBDefault30.dataLabels" [plotOptions]="apexChartCBDefault30.plotOptions"
      [responsive]="apexChartCBDefault30.responsive" [xaxis]="apexChartCBDefault30.xaxis"
      [legend]="apexChartCBDefault30.legend" [fill]="apexChartCBDefault30.fill" [title]="apexChartCBDefault30.title"
      [colors]="apexChartCBDefault30.colors" [grid]="apexChartCBDefault30.grid" [tooltip]="apexChartCBDefault30.tooltip"></apx-chart>

      <ngx-ui-loader [bgsColor]="'red'" [fgsColor]="'red'" [pbColor]="'red'" [bgsOpacity]="1"
      [loaderId]="'loader-CB05'" [bgsPosition]="'center-center'">
      </ngx-ui-loader>
    </div>

    

    <div class="card-Head" *ngIf="element == true && showTileMA == true && last30MerchantShow == true">
      <h5>Merchants Boarding</h5>
    </div>

    <div  *ngIf="element == true && showTileMA == true && last30MerchantShow == true">

      <ngx-ui-loader [bgsColor]="'red'" [fgsColor]="'red'" [pbColor]="'red'" [bgsOpacity]="1"
      [loaderId]="'loader-defaultMerchant30'" [bgsPosition]="'center-center'">
      </ngx-ui-loader>

      <apx-chart [series]="apexChartDefaultMerchant30.series" [chart]="apexChartDefaultMerchant30.chart"
      [dataLabels]="apexChartDefaultMerchant30.dataLabels" [plotOptions]="apexChartDefaultMerchant30.plotOptions"
      [responsive]="apexChartDefaultMerchant30.responsive" [xaxis]="apexChartDefaultMerchant30.xaxis"
      [legend]="apexChartDefaultMerchant30.legend" [fill]="apexChartDefaultMerchant30.fill" [title]="apexChartDefaultMerchant30.title"
      [colors]="apexChartDefaultMerchant30.colors" [grid]="apexChartDefaultMerchant30.grid" [tooltip]="apexChartDefaultMerchant30.tooltip"></apx-chart>

    </div>

    

    

  


    <div class="card-Head mb-2" *ngIf="element == true && showTileMQ == true">
      <h5>Merchants Quality</h5>
    </div>

    <div class="row" *ngIf="element == true && showTileMQ == true">

      <div class="col-md-3 grid-margin stretch-card">
        <div class="card card-bg-color shadow-lg rounded" style="padding: unset;">
          <div class="card-body d-flex justify-content-center" (click)="openModalWidgetActivity(modalWidgetActivity01, activityChartShow)">
            <p *ngIf="activityChartShow == true">
                <apx-chart [series]="apexChart23Options.series" [chart]="apexChart23Options.chart"
                [dataLabels]="apexChart23Options.dataLabels" [plotOptions]="apexChart23Options.plotOptions"
                [responsive]="apexChart23Options.responsive" [xaxis]="apexChart23Options.xaxis" [labels]="apexChart23Options.labels"
                [legend]="apexChart23Options.legend" [fill]="apexChart23Options.fill" [title]="apexChart23Options.title"
                [colors]="apexChart23Options.colors" [grid]="apexChart23Options.grid" [tooltip]="apexChart23Options.tooltip"></apx-chart>     
            </p>
            <p *ngIf="activityChartShow == false">Zero merchant activity</p>            
            <ngx-ui-loader [bgsColor]="'red'" [fgsColor]="'red'" [pbColor]="'red'" [bgsOpacity]="1"
              [loaderId]="'loader-17'" [bgsPosition]="'center-center'">
            </ngx-ui-loader>
          </div>
          <div class="card-footer d-flex justify-content-between" >      
            <div>
            </div>     
            <div class="justify-content-end mt-2">
              <p class="custom-text-size">
                % of Transacted Merchants
              </p>
            </div>
          </div>
       </div>
      </div>

      <ng-template #modalWidgetActivity01 let-modal>
        <div class="modal-header">
          <h5 class="modal-title">% of Merchant transacted and not-transacted</h5>
          <button type="button" class="close" (click)="modal.close('by: close icon')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card-body" align="center">
                <p><b>Last <input type="number" name="customday" [value]="customActivityDays" size="2" min="3" max="30"  (change)="callMerchantActivity($event)"/> days</b></p>
                <p>Min 3 days<input type ="range" name="customday" [value]="customActivityDays" min="3" max="30" (change)="callMerchantActivity($event)" /> Max 30 days</p>
                <!-- <h5>Last {{val1}} days:</h5><p-slider [(ngModel)]="val1" [min]="1" [max]="10" (onChange)="callMerchantActivity($event)"></p-slider> -->

                <apx-chart [series]="apexChart24Options.series" [chart]="apexChart24Options.chart"
                [dataLabels]="apexChart24Options.dataLabels" [plotOptions]="apexChart24Options.plotOptions"
                [responsive]="apexChart24Options.responsive" [xaxis]="apexChart24Options.xaxis" [labels]="apexChart24Options.labels"
                [legend]="apexChart24Options.legend" [fill]="apexChart24Options.fill" [title]="apexChart24Options.title"
                [colors]="apexChart24Options.colors" [grid]="apexChart24Options.grid" [tooltip]="apexChart24Options.tooltip"></apx-chart>     

                <ngx-ui-loader [bgsColor]="'red'" [fgsColor]="'red'" [pbColor]="'red'" [bgsOpacity]="1"
                [loaderId]="'loader-20'" [bgsPosition]="'center-center'">
                </ngx-ui-loader>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 grid-margin stretch-card">
              <div class="card-body">
                <apx-chart [series]="apexChart20Options.series" [chart]="apexChart20Options.chart"
                  [dataLabels]="apexChart20Options.dataLabels" [plotOptions]="apexChart20Options.plotOptions"
                  [responsive]="apexChart20Options.responsive" [xaxis]="apexChart20Options.xaxis" [labels]="apexChart20Options.labels"
                  [legend]="apexChart20Options.legend" [fill]="apexChart20Options.fill" [title]="apexChart20Options.title"
                  [colors]="apexChart20Options.colors" [grid]="apexChart20Options.grid" [tooltip]="apexChart20Options.tooltip"></apx-chart>
              </div>
            </div>
            <div class="col-md-4 grid-margin stretch-card">
              <div class="card-body">
                <apx-chart [series]="apexChart21Options.series" [chart]="apexChart21Options.chart"
                [dataLabels]="apexChart21Options.dataLabels" [plotOptions]="apexChart21Options.plotOptions"
                [responsive]="apexChart21Options.responsive" [xaxis]="apexChart21Options.xaxis" [labels]="apexChart21Options.labels"
                [legend]="apexChart21Options.legend" [fill]="apexChart21Options.fill" [title]="apexChart21Options.title"
                [colors]="apexChart21Options.colors" [grid]="apexChart21Options.grid" [tooltip]="apexChart21Options.tooltip"></apx-chart>     
              </div>
            </div>    
            <div class="col-md-4 grid-margin stretch-card">
              <div class="card-body">
                <apx-chart [series]="apexChart22Options.series" [chart]="apexChart22Options.chart"
                [dataLabels]="apexChart22Options.dataLabels" [plotOptions]="apexChart22Options.plotOptions"
                [responsive]="apexChart22Options.responsive" [xaxis]="apexChart22Options.xaxis" [labels]="apexChart22Options.labels"
                [legend]="apexChart22Options.legend" [fill]="apexChart22Options.fill" [title]="apexChart22Options.title"
                [colors]="apexChart22Options.colors" [grid]="apexChart22Options.grid" [tooltip]="apexChart22Options.tooltip"></apx-chart>     
              </div>
            </div>   
          </div>
        </div>
      </ng-template>      

      <div class="col-md-6 grid-margin stretch-card">
        <div class="card card-bg-color shadow-lg rounded" style="padding: unset; cursor: default;">
          <div style="text-align: right; margin-right: 16px; margin-top: 16px; cursor: pointer;" class="custom-text-size"><p><i (click)="openModalWidgetLongevity(modalWidgetLongevity)" class="link-icon feather icon-help-circle"></i></p></div>
          <div class="card-body d-flex justify-content-center">
              <p *ngIf="longevityChartShow == true">
                <apx-chart [series]="apexChartLongevityOptions.series" [chart]="apexChartLongevityOptions.chart"
                [dataLabels]="apexChartLongevityOptions.dataLabels" [plotOptions]="apexChartLongevityOptions.plotOptions" [yaxis]="apexChartLongevityOptions.yaxis"
                [responsive]="apexChartLongevityOptions.responsive" [xaxis]="apexChartLongevityOptions.xaxis" [labels]="apexChartLongevityOptions.labels"
                [legend]="apexChartLongevityOptions.legend" [fill]="apexChartLongevityOptions.fill" [title]="apexChartLongevityOptions.title"
                [colors]="apexChartLongevityOptions.colors" [grid]="apexChartLongevityOptions.grid" [tooltip]="apexChartLongevityOptions.tooltip"></apx-chart>     
              </p>  
              <p *ngIf="longevityChartShow == false">Zero Merchant in the system</p> 
            <ngx-ui-loader [bgsColor]="'red'" [fgsColor]="'red'" [pbColor]="'red'" [bgsOpacity]="1"
              [loaderId]="'loader-19'" [bgsPosition]="'center-center'">
            </ngx-ui-loader>
          </div>
          <div class="card-footer d-flex justify-content-between" >
            <div>
            </div>
            <div class="justify-content-end mt-2">
              <p class="custom-text-size">
                Aging Analysis
              </p>
            </div>
          </div>
        </div>
      </div>

      <ng-template #modalWidgetLongevity let-modal>
        <div class="modal-header">
          <h5 class="modal-title">Aging Analysis  - How does it calculate?</h5>
          <button type="button" class="close" (click)="modal.close('by: close icon')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- <b>Elapse <input type="number" name="customNTTPNday" [value]="customNTTPNDays" size="2" min="3" max="30"  /> days </b> -->
          This chart helps you understand the longevity of merchants.<br><br>
          <b>Note:</b> It shows % of merchants who have been in the system for various time durations namely less than 30 days and greater than 90 days, 1 year & 2 years.<br>
        </div>
      </ng-template>

      <div class="col-md-3 grid-margin stretch-card">
        <div class="card card-bg-color shadow-lg rounded" style="padding: unset;">
          <div class="card-body d-flex justify-content-center">
              <p *ngIf="mccChartShow == true">
                <apx-chart [series]="apexChartMCCOptions.series" [chart]="apexChartMCCOptions.chart"
                [dataLabels]="apexChartMCCOptions.dataLabels" [plotOptions]="apexChartMCCOptions.plotOptions" 
                [responsive]="apexChartMCCOptions.responsive" [xaxis]="apexChartMCCOptions.xaxis" [labels]="apexChartMCCOptions.labels"
                [legend]="apexChartMCCOptions.legend" [fill]="apexChartMCCOptions.fill" [title]="apexChartMCCOptions.title"
                [colors]="apexChartMCCOptions.colors" [grid]="apexChartMCCOptions.grid" [tooltip]="apexChartMCCOptions.tooltip"></apx-chart>     
              </p>  
              <p *ngIf="mccChartShow == false">Zero MCC Distribution...</p> 
            <ngx-ui-loader [bgsColor]="'red'" [fgsColor]="'red'" [pbColor]="'red'" [bgsOpacity]="1"
              [loaderId]="'loader-18'" [bgsPosition]="'center-center'">
            </ngx-ui-loader>
          </div>
          <div class="card-footer d-flex justify-content-between" >
            <div>
            </div>
            <div class="justify-content-end mt-2">
              <p class="custom-text-size">
                Top 5 MCC Distribution
              </p>
            </div>
          </div>
        </div>
      </div>

    </div> 

      <div [ngClass]="isMobileView ? '' : 'row custom-column'" *ngIf="element == true && showTileMQ == true">
        <app-card *ngIf = "showNTTPNCard" class="col-md-3 grid-margin stretch-card mx-auto" [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}" [Volume]= "notTransactedTPNCount"
        [TimePeriod]="'Have Not Started Transacting'" [List]="'List'"
        (modelOpenClicked)="openModalWidgetNTTPNSetting(modalWidgetNTTPNSetting)"
        (navigateClicked)="openModalWidgetNTTPN('loader-NTTPN')" [loaderId]="'loader-NTTPN'" [cardColor]="'bgColor5'" [label]="'Click to see the calculation'" [text]="'customerText'" [count]="'customer-count'" [cardButton]="'card-button2'">
      </app-card>

      <ng-template #modalWidgetNTTPNSetting let-modal>
        <div class="modal-header">
          <h5 class="modal-title">Have Not Started Transacting (TPNs) - How does it calculate?</h5>
          <button type="button" class="close" (click)="modal.close('by: close icon')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- <b>Elapse <input type="number" name="customNTTPNday" [value]="customNTTPNDays" size="2" min="3" max="30"  /> days </b> -->
          TPN's that have not transacted even after 5 days from the boarding date will appear in this report.<br><br>
          <b>Note:</b> We exclude test transactions or below $5 transactions<br>
        </div>
      </ng-template>
        <app-card class="col-md-3 grid-margin stretch-card mx-auto" [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}" [Volume]= "lessSaleMerchantCount"
        [TimePeriod]="'Declining Sales Trend'" [List]="'List'"
        (modelOpenClicked)="openModalWidgetLSMSetting(modalWidgetLSMSetting)"
        (navigateClicked)="openModalWidgetLSM('loader-LSM')" [loaderId]="'loader-LSM'" [cardColor]="'bgColor5'" [label]="'Click to see the calculation'" [text]="'customerText'" [count]="'customer-count'" [cardButton]="'card-button2'">
      </app-card>

      <ng-template #modalWidgetLSMSetting let-modal>
        <div class="modal-header">
          <h5 class="modal-title">Declining Sales Trend - How does it calculate?</h5>
          <button type="button" class="close" (click)="modal.close('by: close icon')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- <b>Set custom <input type="number" name="customNTTPNday" [value]="customNTTPNDays" size="2" min="3" max="30"  /> days </b> -->          
          Merchants who are transacting less than thier average daily sales consecutively for 7 days will appear in this report.<br><br>
          <b>Note:</b> <br>
          - This report excludes merchants created in last 7 days.<br>
          - Average dailys sales is calculated based on last 90 days sales.<br>
        </div>
      </ng-template>
      <div class="col-md-3"></div>
      <div class="col-md-3"></div>
      <div *ngIf = "!showNTTPNCard" class="col-md-3"></div>
      
    </div>   

    <!-- <zingchart-angular [config]="configUSChart" [height]="500" ></zingchart-angular> -->
  </div>
</div>